import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// @mui
import { styled } from '@mui/material/styles';
import { Stack, Drawer, Typography, Box } from '@mui/material';
// config
import { NAVBAR } from '../../../config';
// components
import Logo from '../../../components/Logo';
import Scrollbar from '../../../components/Scrollbar';
//
import navConfig from './NavConfig';
import { NavSectionVertical } from '../../../components/nav-section';
import useRedux from '../../../hooks/useRedux';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

// ----------------------------------------------------------------------

export default function NavbarVertical({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { appSetting } = useRedux();

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Stack justifyContent="space-between" sx={{ height: '100vh' }}>
        <Box>
          <Stack alignItems="center" sx={{ mt: 5, mb: 2 }} spacing={2.5}>
            <Logo width={72} />
            <Typography variant="subtitle2" color="primary.main">
              {t('Awesome Traffic Bot')}
            </Typography>
          </Stack>

          <NavSectionVertical navConfig={navConfig} />
        </Box>

        <Stack
          sx={{
            background: 'url("/images/copyright.png") no-repeat',
            backgroundPosition: '-15px 10px',
            width: '100%',
            height: 150,
            color: '#95A2B0',
            pb: 4,
          }}
          alignItems="center"
          justifyContent="flex-end"
          spacing={1}
        >
          <Typography variant="caption" sx={{ fontSize: 13 }}>
            {t('Copyright DalgaDev')} 2025
          </Typography>
          <Typography variant="caption" sx={{ fontSize: 12 }}>
            {`UI 2.0.66 | Core ${appSetting.AppVersion}`}
          </Typography>
        </Stack>
      </Stack>
    </Scrollbar>
  );

  return (
    <RootStyle sx={{ width: { xl: NAVBAR.DASHBOARD_WIDTH, xs: NAVBAR.DASHBOARD_WIDTH - 30 } }}>
      <Drawer
        open
        variant="persistent"
        PaperProps={{
          sx: {
            width: { xl: NAVBAR.DASHBOARD_WIDTH, xs: NAVBAR.DASHBOARD_WIDTH - 30 },
            border: 'none',
          },
        }}
      >
        {renderContent}
      </Drawer>
    </RootStyle>
  );
}
